import { render } from "./ColoredLinks.vue?vue&type=template&id=4934355b"
import script from "./ColoredLinks.vue?vue&type=script&lang=js"
export * from "./ColoredLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__